import { render, staticRenderFns } from "./StatementsAcceptance.vue?vue&type=template&id=2b3fbd1a&scoped=true&"
import script from "./StatementsAcceptance.vue?vue&type=script&lang=js&"
export * from "./StatementsAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./StatementsAcceptance.vue?vue&type=style&index=0&id=2b3fbd1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3fbd1a",
  null
  
)

export default component.exports